import GetApi from '../../../common/api/get'

export function setState(params) {
  return {
    type: 'SET_STATE_CANCEL_POLICIES',
    params: params
  }
}

export function get() {
  return async (dispatch, getState) => {
    const getApi = new GetApi()

    await getApi.execute(routeUrlHelper.classificationsCancelPoliciesPath(), '').then((res) => {
      dispatch(setState({ cancel_policy_list: res.body }))
      return true
    }, (res) => {
      dispatch(setState({ error: { main: 'An error occurred' } }))
      return false
    })
  }
}
